import { Image, P } from "../../../../../AbstractElements";
import { Href, MoreCommnets } from "../../../../../Constant";
import { dynamicImage } from "../../../../../Service/DynamicImage";
import IssaBellMessage from "./IssaBellMessage";
import JasonBorneMessage from "./JasonBorneMessage";
import OliviaJonMessage from "./OliviaJonMessage";

const SocialChat = () => {
  return (
    <div className="social-chat">
      <JasonBorneMessage />
      <div className="other-msg">
      <div className="d-flex">
          <Image className="img-50 img-fluid m-r-20 rounded-circle" alt="user" src={dynamicImage("user/2.png")}/>
          <div className="flex-grow-1">
            <span className="f-w-600">Alexendra Dhadio&nbsp;<span>1 Month Ago <i className="fa fa-reply font-primary" /></span></span>
            <P>yes, really very awesome car i see the features of this car in the official website of #Mercedes-Benz and really impressed :-)</P>
          </div>
        </div>
      </div>
      <OliviaJonMessage />
      <IssaBellMessage />
      <div className="text-center">
        <a href={Href}>{MoreCommnets}</a>
      </div>
    </div>
  );
};

export default SocialChat;
